import { render, staticRenderFns } from "./PageHeaderBanner.vue?vue&type=template&id=4143fa7d&scoped=true"
import script from "./PageHeaderBanner.vue?vue&type=script&lang=js"
export * from "./PageHeaderBanner.vue?vue&type=script&lang=js"
import style0 from "./PageHeaderBanner.vue?vue&type=style&index=0&id=4143fa7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4143fa7d",
  null
  
)

export default component.exports